import axios from 'axios';

let baseURL = 'http://aware.senseforth.com'; //NOSONAR

function makeAxiosInstance(options = { botID: null }) {
  return axios.create({
    baseURL: baseURL,
    withCredentials: true,
    data: {
      botid: decodeURIComponent(options.botID) + '',
      mode: options.mode,
      version: options.version
    }
  });
}
let axiosInstance = makeAxiosInstance();

export function setBaseUrl(url, options = { botID: null }) {
  baseURL = url + '/GenericChatBot';

  axiosInstance = makeAxiosInstance(options);
}

const DataAPI = () => {
  return axiosInstance;
};

export default DataAPI;
